import userRouteConfig from './user/userRouteConfig';
import sensorTypeRouteConfig from './sensorType/sensorTypeRouteConfig';
import deviceTypeRouteConfig from './deviceType/deviceTypeRouteConfig';
import infrastructureElementRouteConfig from './infrastructureElement/infrastructureElementRouteConfig';
import deviceRouteConfig from './device/deviceRouteConfig';
import eventRouteConfig from './event/eventRouteConfig';
import measurementRouteConfig from './measurement/measurementRouteConfig';
import projectRouteConfig from './project/projectRouteConfig';
import edaRouteConfig from './eda/edaRouteConfig';
//import bridgeRouteConfig from './bridge/bridgeRouteConfig';
import elementTypeConfig from './elementType/elementTypeConfig';

const AdminConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		...userRouteConfig,
		...sensorTypeRouteConfig,
		...deviceTypeRouteConfig,
		...infrastructureElementRouteConfig,
		...deviceRouteConfig,
		...eventRouteConfig,
		...measurementRouteConfig,
		...projectRouteConfig,
		...edaRouteConfig,
		//...bridgeRouteConfig,
		...elementTypeConfig
	]
};

export default AdminConfig;
